<script>

import AiReport from "../../../../frontend/src/components/startups/AiReport.vue"

export default AiReport
</script>
